import { render, staticRenderFns } from "./FormModals.vue?vue&type=template&id=231655d4&"
import script from "./FormModals.vue?vue&type=script&lang=ts&"
export * from "./FormModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231655d4')) {
      api.createRecord('231655d4', component.options)
    } else {
      api.reload('231655d4', component.options)
    }
    module.hot.accept("./FormModals.vue?vue&type=template&id=231655d4&", function () {
      api.rerender('231655d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingMasterRate/FormModals.vue"
export default component.exports